// extracted by mini-css-extract-plugin
module.exports = {"s18yz36x":"s18yz36x"};